import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import ROUTES from '../constants/routes';
import LoadingScreen from '../components/common/LoadingScreen';

// Lazy loading components for better performance
const Home = lazy(() => import('../pages/Home'));
const About = lazy(() => import('../pages/About'));
const Services = lazy(() => import('../pages/Services'));
const Solutions = lazy(() => import('../pages/Solutions'));
const Industries = lazy(() => import('../pages/Industries'));
const Blog = lazy(() => import('../pages/Blog'));
const BlogDetail = lazy(() => import('../pages/Blog/BlogDetail'));
const CaseStudies = lazy(() => import('../pages/CaseStudies'));
const CaseStudyDetail = lazy(() => import('../pages/CaseStudies/CaseStudyDetail'));
const Careers = lazy(() => import('../pages/Careers'));
const Support = lazy(() => import('../pages/Support'));
const Contact = lazy(() => import('../pages/Contact'));

// ---> THÊM 2 IMPORT MỚI CHO COMMUNITY <---
// const Internship = lazy(() => import('../pages/Internship'));
// const Training = lazy(() => import('../pages/Training'));

// Service pages
const IoTSystemMonitoring = lazy(() => import('../pages/Services/IoTSystemMonitoring'));
const CncServices = lazy(() => import('../pages/Services/CncServices'));
const RobotsServices = lazy(() => import('../pages/Services/RobotsServices'));
const IoTServices = lazy(() => import('../pages/Services/IoTServices'));
const MeasuringServices = lazy(() => import('../pages/Services/MeasuringServices'));

// Auth pages
const Login = lazy(() => import('../pages/Login'));
const Register = lazy(() => import('../pages/Register'));

// Private pages
const Dashboard = lazy(() => import('../pages/Dashboard'));
const CustomerPortal = lazy(() => import('../pages/CustomerPortal'));

// Error pages
const NotFound = lazy(() => import('../pages/NotFound'));

// Loading fallback component is now imported from components
const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        {/* Public Routes */}
        <Route 
          path={ROUTES.HOME} 
          element={
            <PublicRoute>
              <Home />
            </PublicRoute>
          } 
        />
        <Route 
          path={ROUTES.ABOUT} 
          element={
            <PublicRoute>
              <About />
            </PublicRoute>
          } 
        />
        
        {/* Services Route */}
        <Route 
          path={ROUTES.SERVICES} 
          element={
            <PublicRoute>
              <Services />
            </PublicRoute>
          } 
        />
        
        {/* Services Detail Routes */}
        <Route 
          path={ROUTES.SERVICES_CNC} 
          element={
            <PublicRoute>
              <CncServices />
            </PublicRoute>
          } 
        />
        
        <Route 
          path={ROUTES.SERVICES_ROBOTS} 
          element={
            <PublicRoute>
              <RobotsServices />
            </PublicRoute>
          } 
        />
        
        <Route 
          path={ROUTES.SERVICES_IOT} 
          element={
            <PublicRoute>
              <IoTServices />
            </PublicRoute>
          } 
        />
        
        <Route 
          path={ROUTES.SERVICES_MEASURING} 
          element={
            <PublicRoute>
              <MeasuringServices />
            </PublicRoute>
          } 
        />
        
        <Route 
          path={ROUTES.IOT_SYSTEM_MONITORING} 
          element={
            <PublicRoute>
              <IoTSystemMonitoring />
            </PublicRoute>
          } 
        />
        
        {/* Solutions Route */}
        <Route 
          path={ROUTES.SOLUTIONS} 
          element={
            <PublicRoute>
              <Solutions />
            </PublicRoute>
          } 
        />
        
        {/* Industries Route */}
        <Route 
          path={ROUTES.INDUSTRIES} 
          element={
            <PublicRoute>
              <Industries />
            </PublicRoute>
          } 
        />
        
        {/* Blog Routes */}
        <Route 
          path={ROUTES.BLOG} 
          element={
            <PublicRoute>
              <Blog />
            </PublicRoute>
          } 
        />
        <Route 
          path={ROUTES.BLOG_DETAIL} 
          element={
            <PublicRoute>
              <BlogDetail />
            </PublicRoute>
          } 
        />
        
        {/* Case Studies Routes */}
        <Route 
          path={ROUTES.CASE_STUDIES} 
          element={
            <PublicRoute>
              <CaseStudies />
            </PublicRoute>
          } 
        />
        <Route 
          path={ROUTES.CASE_STUDY_DETAIL} 
          element={
            <PublicRoute>
              <CaseStudyDetail />
            </PublicRoute>
          } 
        />
        
        {/* ---> KHU VỰC COMMUNITY ROUTES <--- */}
        <Route 
          path={ROUTES.CAREERS} 
          element={
            <PublicRoute>
              <Careers />
            </PublicRoute>
          } 
        />
        
        {/* <Route 
          path={ROUTES.INTERNSHIP} // Nhớ thêm biến này vào file constants/routes.js
          element={
            <PublicRoute>
              <Internship />
            </PublicRoute>
          } 
        />
        
        <Route 
          path={ROUTES.TRAINING} // Nhớ thêm biến này vào file constants/routes.js
          element={
            <PublicRoute>
              <Training />
            </PublicRoute>
          } 
        /> */}
        
        {/* Support Route */}
        <Route 
          path={ROUTES.SUPPORT} 
          element={
            <PublicRoute>
              <Support />
            </PublicRoute>
          } 
        />
        
        {/* Contact Route */}
        <Route 
          path={ROUTES.CONTACT} 
          element={
            <PublicRoute>
              <Contact />
            </PublicRoute>
          } 
        />

        {/* Auth Routes - restricted for authenticated users */}
        <Route 
          path={ROUTES.LOGIN} 
          element={
            <PublicRoute restrictAuthenticated={true}>
              <Login />
            </PublicRoute>
          } 
        />
        <Route 
          path={ROUTES.REGISTER} 
          element={
            <PublicRoute restrictAuthenticated={true}>
              <Register />
            </PublicRoute>
          } 
        />

        {/* Private Routes - require authentication */}
        <Route 
          path={ROUTES.DASHBOARD} 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } 
        />
        
        <Route 
          path={ROUTES.CUSTOMER_PORTAL} 
          element={
            <PrivateRoute>
              <CustomerPortal />
            </PrivateRoute>
          } 
        />
        
        {/* 404 - Not Found */}
        <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;